import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import { createAdminMenu, deleteAdminMenu, getAllParentMenu, updateAdminMenu } from '../../redux/actions/adminMenu.action';
import { getAdminMenuForm } from "../../redux/actions/adminMenuForm.action"

import CrudButtons from "../../components/CrudButtons/CrudButtons";
import PageHeader from "../../components/PageHeader/PageHeader";
import Tables from '../../components/Table/Tables';

import { Input, Select, Checkbox, Row, Col, Form } from 'antd';
import notification from '../../utils/notification';
import { menuColumns } from "../../utils/cols"

import "../../screens/Product/product.css";
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';
import { GET_ALL_PARENT_MENU_SUCCESS } from '../../redux/actions/types';

const { Option } = Select;

export default function AdminMenu({ token, userRights }) {
    TabTitle("Admin Menu")
    const menuNameInput = useRef(null);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { adminMenuForm } = useSelector(state => state);
    const [formState, setFormState] = useState('view');
    const [disable, setDisable] = useState(false);
    const [menuObj, setMenuObj] = useState(null);
    const [formFieldsValue, setFormFieldsValue] = useState({});
    const [parentMenuList, setParentMenuList] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [isReport, setIsReport] = useState(false);
    const [parentMenuListLoading, setParentMenuListLoading] = useState(false);
    const [parentMenuItemList, setParentMenuItemList] = useState([]);
    const [parentMenuItemListLoading, setParentMenuItemListLoading] = useState(false);

    const { menu_name,
        seq,
        runtime_name,
        component_name,
        menu_type_id,
        parent_menu_id,
        parent_menu_item_id,
        module_id } = form.getFieldValue()

    function onSearch(val) { }

    const handleDelete = () => {
        if (menuObj) {
            dispatch(deleteAdminMenu(token, menuObj.menu_id)).then((res) => {
                if (res.type === "DELETE_ADMIN_MENU_SUCCESS") {
                    notification("success", "Admin Menu ", res.payload?.data);
                }
                if (res.type === "DELETE_ADMIN_MENU_ERROR") {
                    notification("error", " Admin Menu Error");
                }
                form.setFieldsValue({
                    menu_name: null,
                    runtime_name: null,
                    component_name: null,
                    seq: null,
                    menu_type_id: null,
                    module_id: null,
                    parent_menu_item_id: null,
                    parent_menu_id: null,
                });
                setIsActive(true)
                setIsReport(false)
                setMenuObj(null)
                dispatch(getAdminMenuForm(token))
            })
        }
    }

    const formSave = async () => {
        await form.validateFields().then(res => {
            if (formState === "edit") {
                dispatch(updateAdminMenu(token, menu_name, seq, runtime_name, component_name, isActive, isReport, menu_type_id, parent_menu_id, parent_menu_item_id, module_id, menuObj.menu_id)).then((res) => {
                    if (res.type === "UPDATE_ADMIN_MENU_ERROR") {
                        notification("error", "Admin Menu", "Failed")
                    }
                    if (res.type === "UPDATE_ADMIN_MENU_SUCCESS") {
                        notification("success", "Admin Menu", res?.payload?.data)
                    }
                })
            }
            if (formState === "add") {
                dispatch(createAdminMenu(token, {
                    menu_name,
                    seq,
                    runtime_name,
                    component_name,
                    is_active: isActive,
                    is_report: isReport,
                    menu_type_id,
                    parent_menu_id,
                    parent_menu_item_id,
                    module_id,
                })).then((res) => {
                    if (res.type === "ADD_ADMIN_MENU_ERROR") {
                        notification("error", "Admin Menu", "Failed")
                    }
                    if (res.type === "ADD_ADMIN_MENU_SUCCESS") {
                        notification("success", "Admin Menu", res?.payload?.data)
                    }
                })
            }
        }).finally(() => {
            dispatch(getAdminMenuForm(token))
            setFormState("view")
            setMenuObj(null)
            setParentMenuList([])
            setParentMenuItemList([])
            setIsActive(true)
            setIsReport(false)
            form.setFieldsValue({
                menu_name: null,
                runtime_name: null,
                component_name: null,
                seq: null,
                menu_type_id: null,
                module_id: null,
                parent_menu_item_id: null,
                parent_menu_id: null,
            });
        })

    }

    const filterReset = () => {
        setFormState("view")
        setMenuObj(null)
    }

    useEffect(() => {
        dispatch(getAdminMenuForm(token))
    }, [])

    useEffect(() => {
        if (formState === "add") {
            menuNameInput.current.focus();
            form.setFieldsValue({
                menu_name: null,
                runtime_name: null,
                component_name: null,
                seq: null,
                menu_type_id: null,
                module_id: null,
                parent_menu_item_id: null,
                parent_menu_id: null,
            })
            setIsActive(true)
            setIsReport(false)
            setMenuObj(null)
        }
    }, [formState]);

    useLayoutEffect(() => {
        if (!userRights.can_add) {
            setFormState("table")
        }
    }, [userRights])

    useEffect(() => {
        if (menu_name === "") {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [menu_name])

    useEffect(() => {
        if (menuObj) {
            setFormState('view')
            form.setFieldsValue({
                menu_name: menuObj.menu_name,
                seq: menuObj.seq,
                runtime_name: menuObj.runtime_name,
                component_name: menuObj.component_name,
                menu_type_id: menuObj.menu_type_id,
                parent_menu_id: menuObj.parent_menu_id,
                parent_menu_item_id: menuObj.parent_menu_item_id,
                module_id: menuObj.module_id
            });
            setIsActive(menuObj.is_active)
            setIsReport(menuObj.is_report || false)
            if ([2, 3, 4].includes(menuObj.menu_type_id)) {
                getParentMenu({ module_id: menuObj.module_id, menu_type_id: [3, 4].includes(menuObj.menu_type_id) ? 2 : 1 })
                if (menuObj.menu_type_id === 4) {
                    getParentMenu({ module_id: menuObj.module_id, menu_type_id: 3 }, false)
                }
            }
        }
    }, [menuObj]);

    const getParentMenu = (data, flag = true) => {
        flag ? setParentMenuListLoading(true) : setParentMenuItemListLoading(true)
        dispatch(getAllParentMenu(token, data)).then(res => {
            if (res.type === GET_ALL_PARENT_MENU_SUCCESS) {

                flag ? setParentMenuList(res.payload) : setParentMenuItemList(res.payload)
            }
            flag ? setParentMenuListLoading(false) : setParentMenuItemListLoading(false)
        })
    }

    const onValuesChange = (changedValues, allValues) => {
        if (changedValues.menu_type_id) {
            form.setFieldsValue({ parent_menu_id: null, parent_menu_item_id: null })
        }
        if ([2, 3, 4].includes(changedValues.menu_type_id) && module_id || changedValues.module_id && [2, 3, 4].includes(menu_type_id)) {
            getParentMenu({ module_id: allValues.module_id, menu_type_id: [3, 4].includes(allValues.menu_type_id) ? 2 : 1 })
        }
        if (changedValues.menu_type_id === 4 && module_id || changedValues.module_id && menu_type_id === 4) {
            getParentMenu({ module_id: allValues.module_id, menu_type_id: 3 }, false)
        }
        setFormFieldsValue(allValues)
    };

    return <>
        <div className='styleContainer' >
            <div className='styleBody h-100'>
                <PageHeader
                    title={"Admin Menu"} />
                <div className='bodyStyle'>
                    <div className='crudDiv' >
                        <CrudButtons
                            rights={userRights}
                            formType={formState}
                            save={formSave}
                            formState={setFormState}
                            onDelete={handleDelete}
                            disable={disable}
                            reset={filterReset} />
                        <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={24} lg={{ span: 16, order: 2 }} xl={{ span: 16, order: 2 }} >
                                <Form
                                    onFinish={formSave}
                                    onChange={() => { }}
                                    onValuesChange={onValuesChange}
                                    form={form}>
                                    <Form.Item
                                        label="Menu Name"
                                        name="menu_name"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Menu Name is required"
                                            }
                                        ]}>
                                        <Input
                                            size='small'
                                            allowClear
                                            disabled={!(formState === "add" || formState === "edit")}
                                            className='customInputs no-border-first'
                                            ref={menuNameInput} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Admin Module"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}
                                        name="module_id"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select Admin module"
                                            }
                                        ]}>
                                        <Select
                                            size='small'
                                            allowClear
                                            disabled={!(formState === "add" || formState === "edit")}
                                            showSearch
                                            optionFilterProp="children"
                                            onSearch={onSearch}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            filterSort={(optionA, optionB) =>
                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                            }
                                        >
                                            {adminMenuForm?.payload?.adminModule.map((item) => <Option value={item.module_id} key={item.module_id}>{item.module_name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label="Admin Menu Type"
                                        name="menu_type_id"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please Select Admin Menu Type"
                                            }
                                        ]}>
                                        <Select
                                            size='small'
                                            allowClear
                                            disabled={!(formState === "add" || formState === "edit") || module_id === null}
                                            showSearch
                                            optionFilterProp="children"
                                            filterSort={(optionA, optionB) =>
                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                            onSearch={onSearch}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {adminMenuForm?.payload?.adminMenuType.map((item) => <Option value={item.menu_type_id} key={item.menu_type_id}>{item.menu_type_name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label="Parent Menu"
                                        name="parent_menu_id"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}>
                                        <Select
                                            size='small'
                                            loading={parentMenuListLoading}
                                            allowClear
                                            disabled={(!(formState === "add" || formState === "edit")) || menu_type_id === 1 || parent_menu_id?.loading}
                                            showSearch
                                            optionFilterProp="children"
                                            onSearch={onSearch}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            filterSort={(optionA, optionB) =>
                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        >
                                            {parentMenuList?.map((item) => <Option key={item.menu_id} value={item.menu_id}>{item.menu_name}</Option>)}
                                        </Select>
                                    </Form.Item >
                                    <Form.Item
                                        label="Parent Menu Item"
                                        name="parent_menu_item_id"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}>
                                        <Select
                                            size='small'
                                            loading={parentMenuItemListLoading}
                                            allowClear
                                            disabled={(!(formState === "add" || formState === "edit")) || menu_type_id !== 4 || parent_menu_id?.loading}
                                            showSearch
                                            optionFilterProp="children"
                                            onSearch={onSearch}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            defaultValue={form.getFieldValue().parentMenuItem}
                                            filterSort={(optionA, optionB) =>
                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        >
                                            {parentMenuItemList?.map((item) => <Option key={item.menu_id} value={item.menu_id}>{item.menu_name}</Option>)}
                                        </Select>
                                    </Form.Item >
                                    <Form.Item
                                        label="Sequence"
                                        name="seq"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}
                                        rules={[
                                            {
                                                required: true,
                                                pattern: new RegExp(/\d+/g),
                                                message: "Must be a Number!"
                                            }
                                        ]}>
                                        <Input
                                            size='small'
                                            allowClear
                                            disabled={!(formState === "add" || formState === "edit")}
                                            className='customInputs no-border-first'
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        allowClear
                                        label="Runtime Name "
                                        name="runtime_name"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}                                        >
                                        <Input
                                            size='small'
                                            disabled={!(formState === "add" || formState === "edit")}
                                            className='customInputs'
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        allowClear
                                        label="Component Name"
                                        name="component_name"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}>
                                        <Input
                                            size='small'
                                            disabled={!(formState === "add" || formState === "edit")}
                                            className='customInputs'
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Active"
                                        name="is_active"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}>
                                        <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={isActive} onClick={() => setIsActive(!isActive)}></Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                        label="View Report Screen"
                                        name="is_report"
                                        labelCol={{ xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 6 } }}>
                                        <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={isReport} onClick={() => setIsReport(!isReport)}></Checkbox>
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={{ span: 8, order: 1 }} xl={{ span: 6, order: 1 }} >
                                <Tables
                                    formState={formState}
                                    type="adminMenu"
                                    menuObj={setMenuObj}
                                    scrollX={"20rem"}
                                    scroll={620}
                                    perPage={20}
                                    col={menuColumns}
                                    source={adminMenuForm?.payload?.adminMenu || []}
                                    load={adminMenuForm?.loading}
                                    paginate
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    </>;
}
